<div class="contents-area">
  <div class="element-column">
    <div class="column-list">
      <label class="list-input-title">対象</label>
      <div class="list-input-content">
        <app-radio-label name="rbtg_targetGoods" #rbtn_GoodsBase label="商品マスタ"
          id="rbtn_GoodsBase" [subid]="'rbtn_GoodsBase'" value="1" [tabindex]="0"
          [forcedEnabledMode]="'true'" (change)="rbtg_targetGoods_CHANGEHandler()"
          [(ngModel)]="kymw4300Model.rbtg_targetGoods">
        </app-radio-label>
        <app-radio-label name="rbtg_targetGoods" #rbtn_PlanGoods label="商品企画マスタ"
          id="rbtn_PlanGoods" [subid]="'rbtn_PlanGoods'" value="2" [tabindex]="0"
          [forcedEnabledMode]="'true'" (change)="rbtg_targetGoods_CHANGEHandler()"
          [(ngModel)]="kymw4300Model.rbtg_targetGoods">
        </app-radio-label>
      </div>
    </div>

    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">受注コード</label>
        <div class="list-input-content element-row" style="align-items: center;">
          <app-order-code-text-input
            [required]="true" id="txt_OrderCodeFrom" #txt_OrderCodeFrom [subid]="'txt_OrderCodeFrom'"
            [catalogIDField]="lbl_CatalogId_From" [forcedEnabledMode]="'true'" [tabindex]="0" 
            [(ngModel)]="kymw4300Model.orderCodeFrom" (ngModelChange)="clickChangeCatalogIdFrom()">
          </app-order-code-text-input>
          <input type="text" class="deliv-catalog" readonly
            id="lbl_CatalogId_From" #lbl_CatalogId_From [(ngModel)]="kymw4300Model.catalogId_From">
          <label>～</label>
          <app-order-code-text-input type="text"
            id="txt_OrderCodeTo" #txt_OrderCodeTo [subid]="'txt_OrderCodeTo'" [required]="true"
            [catalogIDField]="lbl_CatalogId_To" [forcedEnabledMode]="'true'" [tabindex]="0"
            [(ngModel)]="kymw4300Model.orderCodeTo" (ngModelChange)="clickChangeCatalogIdTo()">
          </app-order-code-text-input>
          <input type="text" class="deliv-catalog" readonly
            id="lbl_CatalogId_To" #lbl_CatalogId_To [(ngModel)]="kymw4300Model.catalogId_To">
        </div>
      </div>
      <div class="column-list">
        <label class="list-input-title">媒体</label>
        <div class="list-input-content">
          <app-plan-medium-type-combo-box #cmb_MediumType id="cmb_MediumType" [subid]="'cmb_MediumType'"
            [tabindex]="0" [forcedEnabledMode]="'true'" [width]="'438px'">
          </app-plan-medium-type-combo-box>
        </div>
      </div>
    </div>
  </div>

  <wj-tab-panel #tab_pCode
    id="tab_pCode" creationPolicy="all" forcedEnabledMode="true"
    horizontalAlign="left" [tabindex]="-1">
    <div class="tabBox1">
      <wj-tab>

        <a>通常検索</a>
        <div class="element-column">
          <wj-accordion #wad_goods [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
          (initialized)="initCollapsed(wad_goods, false)">
          <wj-accordion-pane>
            <div>商品関連条件</div>
            <div>
              <div class="element-column">
                <div class="block-row">
                  <div class="column-list">
                    <label class="list-input-title">Ｐコード</label>
                    <div class="list-input-content">
                      <input type="text" #tbx_PCode id="tbx_PCode" [tabindex]="0" class="pcode"
                        forcedEnabledMode="true" [maxlength]="8" plessInputTextSub [restrict]="'[P0-9]'"
                        [(ngModel)]="kymw4300Model.pCode">
                    </div>
      
                    <label class="list-input-title">訂正元eBASE NO</label>
                    <div class="list-input-content">
                      <input type="text" #tbx_ebaseSpecCode id="tbx_ebaseSpecCode" [tabindex]="0"
                        forcedEnabledMode="true" [maxlength]="26" plessInputTextSub [restrict]="'[ -~]'"
                        [(ngModel)]="kymw4300Model.eBaseSpecCode" [style.width.rem]="18">
                    </div>
      
                    <label class="list-input-title">JANコード</label>
                    <div class="list-input-content">
                      <input type="text" #tbx_JANCode id="tbx_JANCode" class="jan-code"
                        [tabindex]="0" forcedEnabledMode="true" [maxlength]="13" plessInputTextSub [restrict]="'[0-9]'"
                        [(ngModel)]="kymw4300Model.jANCode">
                    </div>
      
                    <label class="list-input-title">商品案内用商品名</label>
                    <div class="list-input-content">
                      <app-text-input #tbx_GuideGoodsName id="tbx_GuideGoodsName" [subid]="'tbx_GuideGoodsName'"
                        [forcedEnabledMode]="'true'" [tabindex]="0" [fullOnly]="true" [restrict]="'[ -￮]'"
                        [displayCountField]="false" class="guide-goods-name">
                      </app-text-input>
                    </div>
      
                    <label class="list-input-title">取扱終了商品</label>
                    <div class="list-input-content">
                      <app-checkbox-label #chk_DealStopGoodsDisplay label="出力する" id="chk_DealStopGoodsDisplay"
                        [subid]="'chk_DealStopGoodsDisplay'" [tabindex]="0" [forcedEnabledMode]="'true'">
                      </app-checkbox-label>
                    </div>
      
                    <label class="list-input-title">取扱可能生協</label>
                    <div class="list-input-content">
                      <app-checkbox-label #chb_Seikyou1 label="い" id="chb_Seikyou1" [subid]="'chb_Seikyou1'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou2 label="と" id="chb_Seikyou2" [subid]="'chb_Seikyou2'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou3 label="ぐ" id="chb_Seikyou3" [subid]="'chb_Seikyou3'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou4 label="ち" id="chb_Seikyou4" [subid]="'chb_Seikyou4'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou5 label="さ" id="chb_Seikyou5" [subid]="'chb_Seikyou5'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou6 label="とう" id="chb_Seikyou6" [subid]="'chb_Seikyou6'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou7 label="な" id="chb_Seikyou7" [subid]="'chb_Seikyou7'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                      <app-checkbox-label #chb_Seikyou8 label="に" id="chb_Seikyou8" [subid]="'chb_Seikyou8'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                    </div>
                  </div>
      
      
                  <div class="column-list">
                    <label class="list-input-title">アイテムコード</label>
                    <div class="list-input-content">
                      <input type="text" #tbx_ItemCode id="tbx_ItemCode" [tabindex]="0" forcedEnabledMode="true"
                        class="item-code" [maxlength]="7" plessInputTextSub [restrict]="'[0-9]'"
                        [(ngModel)]="kymw4300Model.itemCode">
                    </div>
      
                    <div class="hidden_content"></div>
                    <div class="hidden_content"></div>
      
                    <label class="list-input-title">メーカー名</label>
                    <div class="list-input-content">
                      <app-text-input #tbx_MakerName id="tbx_MakerName" [subid]="'tbx_MakerName'" [forcedEnabledMode]="'true'"
                        [tabindex]="0" [maxChars]="20" [fullOnly]="true" [restrict]="'[ -￮]'" [displayCountField]="false"
                        [(ngModel)]="kymw4300Model.makerName" [width]="'22rem'">
                      </app-text-input>
                    </div>
      
                    <label class="list-input-title">商品案内用規格名</label>
                    <div class="list-input-content">
                      <app-text-input #tbx_GuideStandardName
                        id="tbx_GuideStandardName" [subid]="'tbx_GuideStandardName'" [forcedEnabledMode]="'true'"
                        [tabindex]="0" [fullOnly]="true" [restrict]="'[ -￮]'" [displayCountField]="false" class="guide-standard-name">
                      </app-text-input>
                    </div>
      
                    <label class="list-input-title">ダミー商品</label>
                    <div class="list-input-content">
                      <app-checkbox-label #chk_DummyGoods id="chk_DummyGoods" [subid]="'chk_DummyGoods'"
                        [tabindex]="0" [forcedEnabledMode]="'true'"></app-checkbox-label>
                    </div>
                  </div>
                </div>
      
                <div class="block-row">
                  <div class="column-list">
                    <label class="list-input-title">バイヤーコード</label>
                    <div class="list-input-content">
                      <app-code-combo-box #cmb_BuyerCode id="cmb_BuyerCode" [subid]="'cmb_BuyerCode'"
                        [codeDiv]="'ct357'" [labelField]="'codeValueName'" [tabindex]="0"
                        [forcedEnabledMode]="'true'">
                      </app-code-combo-box>
                    </div>
                  </div>
      
                  <div class="column-list">
                    <label class="list-input-title">登録レベル</label>
                    <div class="list-input-content">
                      <app-code-combo-box id="cmb_AdmitStatusGroup" #cmb_AdmitStatusGroup [subid]="'cmb_admitStatus'"
                        [(ngModel)]="kymw4300Model.cmb_AdmitStatusGroup" [codeDiv]="'ctp322'" [labelField]="'CodeName'"
                        [autofocus]="true" [forcedEnabledMode]="'true'" [tabindex]="0" [width]="180" 
                        [required]="true" [blank]="false">
                      </app-code-combo-box>
                    </div>
                  </div>
                </div>
      
                <div>
                  <div class="column-list">
                    <div class="list-input-title">マスタ登録日</div>
                    <div class="list-input-content">
                      <wj-input-date #dtf_StartRegistDate id="dtf_StartRegistDate" yearNavigationEnabled="true"
                        forcedEnabledMode="true" [tabindex]="0" [value]="null" [isRequired]="false"
                        (valueChange)="eventRegistDateHandler(null)">
                      </wj-input-date>
                      <label>～</label>
                      <wj-input-date #dtf_EndRegistDate id="dtf_EndRegistDate" yearNavigationEnabled="true"
                      forcedEnabledMode="true" [tabindex]="0" [value]="null" [isRequired]="false"
                        (valueChange)="eventRegistDateHandler(null)">
                      </wj-input-date>
                    </div>
      
                    <div class="list-input-title">マスタ更新日</div>
                    <div class="list-input-content block-row">
                      <wj-input-date #dtf_StartUpdateDate id="dtf_StartUpdateDate" yearNavigationEnabled="true"
                        forcedEnabledMode="true" [tabindex]="0" [value]="null" [isRequired]="false"
                        (valueChange)="eventUpdateDateHandler(null)">
                      </wj-input-date>
                      <label>～</label>
                      <wj-input-date #dtf_EndUpdateDate id="dtf_EndUpdateDate" yearNavigationEnabled="true"
                        forcedEnabledMode="true" [tabindex]="0" [value]="null" [isRequired]="false"
                        (valueChange)="eventUpdateDateHandler(null)">
                      </wj-input-date>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </wj-accordion-pane>
        </wj-accordion>

        <wj-accordion #wad_dna [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_dna)">
          <wj-accordion-pane>
            <div>DNA情報</div>
            <div>
              <div class="column-list">
                <label class="list-input-title">DNA情報</label>
                <div class="list-input-content">
                  <app-dna-info-check-box-list [height]="'195px'" [width]="'max-content'" #lst_DNAInfoList id="lst_DNAInfoList"
                    [subid]="'lst_DNAInfoList'" horizontalScrollPolicy="off" verticalScrollPolicy="on"
                    [forcedEnabledMode]="'true'" liveScrolling="false" selectionColor="#CCE5FF" [tabindex]="0"
                    invalidCode="00" editable="true" rendererIsEditor="true" editorDataField="selectedValue">
                  </app-dna-info-check-box-list>
                </div>
              </div>
            </div>
          </wj-accordion-pane>
        </wj-accordion>

        <wj-accordion #wad_class [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
                  (initialized)="initCollapsed(wad_class)">
          <wj-accordion-pane>
            <div>部門分類条件</div>
            <div>
              <div class="column-list">
                <label class="list-input-title">部門</label>
                <div class="list-input-content" style="width:300px;">
                  <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode"
                    [subid]="'cmb_ClassCode'" [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true"
                    [initFocusItem]="rbtn_GoodsBase">
                  </app-class-code-combo-box>
                </div>

                <label class="list-input-title">中分類</label>
                <div class="list-input-content">
                  <app-middle-class-code-combo-box #cmb_MiddleClassification
                    id="cmb_MiddleClassification" [subid]="'cmb_MiddleClassification'" [forcedEnabledMode]="'true'"
                    [tabindex]="0" [blank]="true" [initFocusItem]="rbtn_GoodsBase"
                    [classCode]="cmb_ClassCode.selectedClassCode" [classCodeComboBoxFlg]="true">
                  </app-middle-class-code-combo-box>
                </div>

                <label class="list-input-title">小分類</label>
                <div class="list-input-content">
                  <app-small-class-code-combo-box #cmb_SmallClassification
                    id="cmb_SmallClassification" [subid]="'cmb_SmallClassification'" [tabindex]="0" [blank]="true"
                    [forcedEnabledMode]="'true'" [initFocusItem]="rbtn_GoodsBase"
                    [classCode]="cmb_ClassCode.selectedClassCode"
                    [middleClassCode]="cmb_MiddleClassification.selectedMiddleClassCode" [classCodeComboBoxFlg]="true">
                  </app-small-class-code-combo-box>
                </div>
              </div>
            </div>
          </wj-accordion-pane>
        </wj-accordion>

        <wj-accordion #wad_supplier [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
        (initialized)="initCollapsed(wad_supplier)">
        <wj-accordion-pane>
          <div>取引先関連条件</div>
          <div>
            <div class="element-column">
              <div class="block-row">
                <div class="column-list">
                  <label class="list-input-title">発注先コード</label>
                  <div class="list-input-content">
                    <input #tbx_OrdrClientCode type="text" [style.width.rem]="7" id="tbx_OrdrClientCode"
                      [(ngModel)]="kymw4300Model.ordrClientCode" [tabindex]="0" forcedEnabledMode="true"
                      plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6">
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">発注先名</label>
                  <div class="list-input-content">
                    <app-text-input #tbx_OrdrClientKanji id="tbx_OrdrClientKanji" [subid]="'tbx_OrdrClientKanji'"
                      [tabindex]="0" [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [displayCountField]="false">
                    </app-text-input>
                    <button id="btn_SearchOrdrClient" class="btn-secondary" [tabindex]="0" forcedEnabledMode="true"
                      (click)="eventSearchOrdrClientHandler()">検索</button>
                  </div>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list">
                  <label class="list-input-title">支払先コード</label>
                  <div class="list-input-content">
                    <input #tbx_PayeeClientCode type="text" [style.width.rem]="7" id="tbx_PayeeClientCode"
                      [(ngModel)]="kymw4300Model.payeeClientCode" [tabindex]="0" forcedEnabledMode="true"
                      plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6">
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">支払先名</label>
                  <div class="list-input-content">
                    <app-text-input #tbx_PayeeClientKanji id="tbx_PayeeClientKanji" [subid]="'tbx_PayeeClientKanji'"
                      [tabindex]="0" [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [displayCountField]="false">
                    </app-text-input>
                    <button id="btn_SearchPayeeClient" class="btn-secondary" [tabindex]="0" forcedEnabledMode="true"
                      (click)="eventSearchPayeeHandler()">検索</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </wj-accordion-pane>
        </wj-accordion>

        <wj-accordion #wad_duties [isAnimated]="false" [allowCollapseAll]="true" [allowExpandMany]="true"
        (initialized)="initCollapsed(wad_duties)">
        <wj-accordion-pane>
          <div>業態区分条件</div>
          <div>
            <div class="element-column">
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">ウィークリー</label>
                <div class="list-input-content">
                  <app-checkbox-label #chb_DutiesFormWeeklyDiv label="掲載あり" id="chb_DutiesFormWeeklyDiv"
                    [subid]="'chb_DutiesFormWeeklyDiv'" [tabindex]="0" [forcedEnabledMode]="'true'">
                  </app-checkbox-label>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">スポット</label>
                <div class="list-input-content">
                  <app-checkbox-label #chb_DutiesFormSpotDiv label="掲載あり" id="chb_DutiesFormSpotDiv"
                    [subid]="'chb_DutiesFormSpotDiv'" [tabindex]="0" [forcedEnabledMode]="'true'">
                  </app-checkbox-label>
                </div>
              </div>
            </div>

            <div class="column-list" style="width:444px;">
              <label class="list-input-title daily-title">デイリー</label>
              <div class="list-input-content daily-content">
                <app-code-check-box-list [height]="'29px'" #lst_DutiesFormDaily [codeDiv]="'ctp123'"
                  id="lst_DutiesFormDaily" [subid]="'lst_DutiesFormDaily'" horizontalScrollPolicy="off"
                  verticalScrollPolicy="on" [forcedEnabledMode]="'true'" liveScrolling="false"
                  selectionColor="#CCE5FF" [tabindex]="0" invalidCode="00" editable="true" rendererIsEditor="true"
                  editorDataField="selectedValue"></app-code-check-box-list>
              </div>
            </div>
          </div>
          </div>
        </wj-accordion-pane>
        </wj-accordion>
        </div>

      </wj-tab>

      <wj-tab>
        <a>リスト検索(Pコード)</a>
        <div style="height: 730px;" class="input_vertical pcode_list_search">
          <div class="layout_balance">
            <label class="list-input-title">Ｐコードリスト</label>
            <label class="count-field">{{ pcodeCount }}件/200件</label>
          </div>
          <div class="block-row">
            <div class="list-input-content">
              <textarea #txta_PcodeList plessInputTextSub
                id="txta_PcodeList" forcedEnabledMode="true"
                [restrict]="'[P0-9\n]'" wordWrap="true" [tabindex]="0"
                [(ngModel)]="kymw4300Model.pCodeList" class="text-label-required"></textarea>
            </div>
            <div class="element-column">
              <label>・１行１件のＰコードを入力してください。</label>
              <label>・一度に入力できるＰコードは最大200件までとします。</label>
            </div>
          </div>
        </div>
      </wj-tab>
    </div>
  </wj-tab-panel>
</div>

<footer class="footer-buttons">
  <button
    id="btn_ConditionClear" class="btn-tartiary" #btn_ConditionClear
    (keydown)="eventMoveToListSeachTabHandler($event)" (click)="eventConditionClearHandler()"
    forcedEnabledMode="true" [tabindex]="0">条件クリア</button>
  <button id="btn_Output" class="btn-primary" (click)="eventOutput_CLICKHandler(null)"
    forcedEnabledMode="true" [tabindex]="0">出力</button>
</footer>